__turbopack_context__.v({
  "button": "install-button-module__qXxZhq__button",
  "done": "install-button-module__qXxZhq__done",
  "how": "install-button-module__qXxZhq__how",
  "wrap": "install-button-module__qXxZhq__wrap",
});
